// extracted by mini-css-extract-plugin
export default {"root":"LoadingProgress_root__Q+ZEa","progressSlot":"LoadingProgress_progressSlot__thjwQ","title":"LoadingProgress_title__JVTAv","subtitle":"LoadingProgress_subtitle__bTIBr"};